export default "__VITE_ASSET__NzH5FuxG__"